import styled from '@emotion/styled';
import BrandCard from '../BrandCard';

export const Content = styled(BrandCard)({ margin: 'auto', gap: '3px' });
